import { render, staticRenderFns } from "./ProductSearchCard.vue?vue&type=template&id=37673450"
import script from "./ProductSearchCard.vue?vue&type=script&lang=js"
export * from "./ProductSearchCard.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchCard.vue?vue&type=style&index=0&id=37673450&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports